import hopperButton from '../../assets/setup/tutorial_hopper_move.png';

// component props interface 
interface Props {
    isMobileView: boolean;
}


export const FloatingHopperButton: React.FC<Props> = ({ isMobileView }) => {
    return (
        <div className="flex flex-col justify-center  gap-y-1">
            <p>Floating Hopper button is available on Android and can be used to switch between Active Mode or Settings Mode if persistent navigation bar is disabled.
            </p>
            <ul className="flex flex-col gap-y-2 list-disc list-inside">
                <li>Tap on the floating Hopper button to switch between  Active Mode or Settings Mode.</li>
                <li>The floating Hopper button can be moved around by long pressing and dragging. It will remember its position in each deck.</li>
            </ul>
            <img className="mt-2 mb-3" src={hopperButton} alt="Floating Hopper Button" width="300" />
        </div>
    )
}